// Game-icons' "concentration orb" (the set react-icons' Gi* icons come from), drawn white.
import concentratingIcon from '../assets/icons/Concentrating.svg';

// Public self-registration at /signup. Off for now: the route redirects to login and the
// "Register" links are hidden. Invite links (/join/:code) still let invited players sign up.
export const SIGNUP_ENABLED = false;

export const CONDITION_ICONS = {
    BLINDED: require("../assets/icons/FinalBlinded.webp"),
    CHARMED: require("../assets/icons/Charmed.webp"),
    DEAF: require("../assets/icons/FinalDeafened.webp"),
    FRIGHTENED: require("../assets/icons/Frightened.webp"),
    GRAPPLED: require("../assets/icons/FinalGrappled.webp"),
    INCAPACITATED: require("../assets/icons/FinalIncapacitated.webp"),
    INVISIBLE: require("../assets/icons/FinalInvisible.webp"),
    PARALYZED: require("../assets/icons/FinalParalyzed.webp"),
    PETRIFIED: require("../assets/icons/FinalPetrified.webp"),
    POISONED: require("../assets/icons/FinalPoisoned.webp"),
    PRONE: require("../assets/icons/FinalProne.webp"),
    RESTRAINED: require("../assets/icons/FinalRestrained.webp"),
    STUNNED: require("../assets/icons/FinalStunned.webp"),
    UNCONSCIOUS: require("../assets/icons/Unconcious.webp")
};

export const CONDITIONS = [
    {id: 'blinded',       label: 'Blinded',       color: '#546E7A', icon: CONDITION_ICONS.BLINDED},
    {id: 'charmed',       label: 'Charmed',       color: '#E91E63', icon: CONDITION_ICONS.CHARMED},
    {id: 'deafened',      label: 'Deafened',      color: '#90A4AE', icon: CONDITION_ICONS.DEAF},
    {id: 'frightened',    label: 'Frightened',    color: '#9C27B0', icon: CONDITION_ICONS.FRIGHTENED},
    {id: 'grappled',      label: 'Grappled',      color: '#FF9800', icon: CONDITION_ICONS.GRAPPLED},
    {id: 'incapacitated', label: 'Incapacitated', color: '#FF5722', icon: CONDITION_ICONS.INCAPACITATED},
    {id: 'invisible',     label: 'Invisible',     color: '#B0BEC5', icon: CONDITION_ICONS.INVISIBLE},
    {id: 'paralyzed',     label: 'Paralyzed',     color: '#FDD835', icon: CONDITION_ICONS.PARALYZED},
    {id: 'petrified',     label: 'Petrified',     color: '#78909C', icon: CONDITION_ICONS.PETRIFIED},
    {id: 'poisoned',      label: 'Poisoned',      color: '#43A047', icon: CONDITION_ICONS.POISONED},
    {id: 'prone',         label: 'Prone',         color: '#8BC34A', icon: CONDITION_ICONS.PRONE},
    {id: 'restrained',    label: 'Restrained',    color: '#E53935', icon: CONDITION_ICONS.RESTRAINED},
    {id: 'stunned',       label: 'Stunned',       color: '#039BE5', icon: CONDITION_ICONS.STUNNED},
    {id: 'unconscious',   label: 'Unconscious',   color: '#3949AB', icon: CONDITION_ICONS.UNCONSCIOUS},
    // Not a 5e condition but tracked like one - see utilities/concentration.js.
    {id: 'concentrating', label: 'Concentrating', color: '#7E57C2', icon: concentratingIcon},
];

// CONDITION_IMAGES (src/assets/conditions/appa-*.png) was removed along with the art it
// pointed at: those illustrations were third-party and could not be shipped. The condition
// panels in DndQuickReference and DndQuickReference2024 now render text only. The separate
// CONDITION_ICONS set above is ours and stays — it is what tokens and ConditionsGrid use.

export const AOE_IMAGES = {
    ACID: require("../assets/aoe/acid_aoe.webp"),
    BLUDGEON: require("../assets/aoe/bludgeon_aoe.webp"),
    COLD: require("../assets/aoe/cold_aoe.webp"),
    FIRE: require("../assets/aoe/fire_aoe.webp"),
    FORCE: require("../assets/aoe/force_aoe.webp"),
    NECROTIC: require("../assets/aoe/necrotic_aoe.webp"),
    LIGHTNING: require("../assets/aoe/lightning_aoe.webp"),
    PSYCHIC: require("../assets/aoe/psychic_aoe.webp"),
    RADIANT: require("../assets/aoe/radiant_aoe.webp"),
    THUNDER: require("../assets/aoe/thunder_aoe.webp"),
    WEB: require("../assets/aoe/web_aoe.webp"),
    NATURE: require("../assets/aoe/nature_aoe.webp"),
    POISON: require("../assets/aoe/poison_aoe.webp"),
    SLASH: require("../assets/aoe/slashing_aoe.webp"),
    PIERCE: require("../assets/aoe/piercing_aoe.webp"),
    WATER: require("../assets/aoe/water_aoe.webp"),
    GREASE: require("../assets/aoe/grease_aoe.webp")
};